export default {
  admin: () => import("/opt/atlassian/pipelines/agent/build/layouts/admin.vue").then(m => m.default || m),
  app: () => import("/opt/atlassian/pipelines/agent/build/layouts/app.vue").then(m => m.default || m),
  checkout: () => import("/opt/atlassian/pipelines/agent/build/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m),
  landingpage: () => import("/opt/atlassian/pipelines/agent/build/layouts/landingpage.vue").then(m => m.default || m),
  widget: () => import("/opt/atlassian/pipelines/agent/build/layouts/widget.vue").then(m => m.default || m)
}